var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 6.70478C20.3258 6.98925 19.6108 7.17597 18.8788 7.25875C19.6413 6.82334 20.2268 6.13386 20.5025 5.31235C19.7776 5.72215 18.9845 6.01089 18.1575 6.16608C17.4838 5.48235 16.5241 5.05505 15.4619 5.05505C13.4224 5.05505 11.7689 6.63029 11.7689 8.57314C11.7689 8.84892 11.8016 9.1174 11.8645 9.37496C8.79539 9.22819 6.0743 7.82759 4.25286 5.69905C3.93504 6.21866 3.75293 6.82307 3.75293 7.46774C3.75293 8.68835 4.40494 9.76515 5.39579 10.3961C4.80934 10.3786 4.2358 10.2277 3.72305 9.95599C3.72284 9.97073 3.72284 9.98546 3.72284 10.0003C3.72284 11.7049 4.99578 13.1268 6.68511 13.45C6.1413 13.5909 5.57088 13.6115 5.01743 13.5103C5.48733 14.908 6.85118 15.9251 8.46711 15.9536C7.20324 16.8972 5.61087 17.4597 3.88076 17.4597C3.58264 17.4597 3.28873 17.443 2.99982 17.4105C4.63409 18.4087 6.57521 18.9911 8.66068 18.9911C15.4534 18.9911 19.1678 13.6302 19.1678 8.98115C19.1678 8.82855 19.1642 8.67683 19.1571 8.52598C19.88 8.02807 20.5041 7.41135 20.9998 6.70478Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white",
    transform: "translate(2.99982 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6e5e440941cdc0f5ecd0f76a1b31c694.svg";
export { ForwardRef as ReactComponent };